import React, { createContext, useContext } from 'react';

type ArticleHeaderContextValue = { articleId: string } | null;

const ArticleHeaderContext = createContext<ArticleHeaderContextValue>(null);

export const ArticleHeaderProvider: React.FC<{ articleId: string; children: React.ReactNode }> = ({ articleId, children }) => (
  <ArticleHeaderContext.Provider value={{ articleId }}>
    {children}
  </ArticleHeaderContext.Provider>
);

export const useArticleHeader = () => useContext(ArticleHeaderContext);
